if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.counter = this.querySelector('[data-modal-counter]');

        this.querySelectorAll('[data-modal-nav]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigate(button.getAttribute('data-modal-nav'));
          });
        });

        // Close on tap/click anywhere except nav, close, and playable media
        this.addEventListener('pointerup', (event) => {
          if (
            event.target.closest(
              '[data-modal-nav], .product-media-modal__toggle, deferred-media, product-model'
            )
          ) {
            return;
          }
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code === 'ArrowLeft') this.navigate('prev');
          if (event.code === 'ArrowRight') this.navigate('next');
        });
      }

      get mediaElements() {
        return [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.mediaElements;

        items.forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });

        const activeMedia = items.find((element) => element.classList.contains('active')) || items[0];
        if (!activeMedia) return;

        activeMedia.classList.add('active');
        this.updateCounter(items.indexOf(activeMedia));

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      navigate(direction) {
        const items = this.mediaElements;
        if (items.length < 2) return;

        const activeIndex = items.findIndex((element) => element.classList.contains('active'));
        let nextIndex = direction === 'next' ? activeIndex + 1 : activeIndex - 1;
        if (nextIndex < 0) nextIndex = items.length - 1;
        if (nextIndex >= items.length) nextIndex = 0;

        items.forEach((element) => element.classList.remove('active'));
        const nextMedia = items[nextIndex];
        nextMedia.classList.add('active');
        this.updateCounter(nextIndex);

        const activeMediaTemplate = nextMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          nextMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          nextMedia.loadContent();
        }
      }

      updateCounter(index) {
        if (!this.counter) return;
        const total = this.mediaElements.length;
        if (index < 0 || !total) return;
        this.counter.textContent = `${index + 1} / ${total}`;
      }
    }
  );
}
